import { Message as message } from 'element-ui'
export const Message = options => {
  return message({
    ...options,
    showClose: true
  })
}
const types = ['success', 'info', 'warning', 'error']
types.forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = { message: options, showClose: true }
    }
    options.type = type
    return message(options)
  }
})

